export const BRAND_NAME = 'M/Y Christina'
export const BRAND_ABBR_TITLE = 'Motor Yacht'

export const MAX_GUESTS = 25
export const MAX_PARKING = 4

export const HOURS_OPEN = '12:00 PM'
export const HOURS_CLOSE = '12:00 AM'

export const ADDRESS_EN = '110 Nile Street. Dokki, Egypt.'
export const ADDRESS_DETAILS_EN = 'Next to El Galaa Bridge and in front of Cairo Sheraton Hotel'
export const ADDRESS_AR = '١١٠ ش كورنيش النيل، الدقى، الجيزة'
export const ADDRESS_DETAILS_AR = 'أمام فندق شيراتون القاهرة'
